import { TableEmptyState } from '@practium/ui';
import { formatDateFromISO } from '@practium/shared';
import type { Sector } from '../../../types';
import styles from '../PropertiesTable.module.css';

interface SectorsTableProps {
	sectors: Sector[];
	onRowClick?: (id: string) => void;
	showProperty?: boolean;
}

export const SectorsTable = ({ sectors, onRowClick, showProperty = true }: SectorsTableProps) => {
	if (sectors.length === 0) {
		return (
			<TableEmptyState
				title="Nenhum setor encontrado"
				subtitle="Adicione um setor à propriedade para começar"
			/>
		);
	}

	return (
		<div className={styles.tableWrapper}>
			<table className={styles.table}>
				<thead className={styles.thead}>
					<tr>
						<th>Nome</th>
						<th>Área</th>
						{showProperty && <th>Propriedade</th>}
						<th>Plantio</th>
						<th>Tamanho</th>
						<th>Qtd. Plantas</th>
					</tr>
				</thead>
				<tbody className={styles.tbody}>
					{sectors.map(item => (
						<tr
							key={item._id}
							onClick={() => onRowClick?.(item._id)}
							className={onRowClick ? styles.clickableRow : undefined}
						>
							<td>
								<span className={styles.cellPrimary}>{item.name}</span>
							</td>
							<td>
								<span className={styles.cellSecondary}>{item.areaName}</span>
							</td>
							{showProperty && (
								<td>
									<span className={styles.cellSecondary}>{item.propName}</span>
								</td>
							)}
							<td>
								<span className={styles.cellSecondary}>{formatDateFromISO(item.plantingDate)}</span>
							</td>
							<td>
								<span className={styles.cellSecondary}>{item.size} ha</span>
							</td>
							<td>
								<span className={styles.cellNumber}>{item.amountOfPlants.toLocaleString('pt-BR')}</span>
							</td>
						</tr>
					))}
				</tbody>
			</table>
		</div>
	);
};
